import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import {
	HistoryService,
	ModalSize,
	RoutedModalBaseComponent,
	SlottedModalComponent,
	SvgIconComponent,
} from '@woolworthsnz/styleguide';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { NgIf, AsyncPipe } from '@angular/common';
import { FulfilmentStoreService } from '@woolworthsnz/fulfilment';
import { FulfilmentWindowSummarySlot } from '@woolworthsnz/trader-api';

@Component({
	selector: 'wnz-pickup-point-information-modal',
	templateUrl: './pickup-point-information-modal.component.html',
	styleUrls: ['./pickup-point-information-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [SlottedModalComponent, NgIf, SvgIconComponent, AsyncPipe],
})
export class PickupPointInformationModalComponent extends RoutedModalBaseComponent implements OnInit {
	size = ModalSize.Medium;
	driveInstruction$: Observable<string>;

	constructor(
		protected router: Router,
		protected historyService: HistoryService,
		protected activatedRoute: ActivatedRoute,
		private fulfilmentStoreService: FulfilmentStoreService
	) {
		super(router, activatedRoute, historyService);
	}

	ngOnInit(): void {
		this.driveInstruction$ = this.fulfilmentStoreService.state$.pipe(
			map((state) => {
				const slots = !state.daySlots
					? []
					: (state.daySlots as any)[
							state.clientSelectedDate?.toString() || state.selectedDate?.toString() || ''
					  ]?.filter((fulfillmentWindowSummarySlot: FulfilmentWindowSummarySlot) =>
							[
								FulfilmentWindowSummarySlot.StatusEnum.Available,
								FulfilmentWindowSummarySlot.StatusEnum.ClosingSoon,
								FulfilmentWindowSummarySlot.StatusEnum.Selected,
								FulfilmentWindowSummarySlot.StatusEnum.Full,
								FulfilmentWindowSummarySlot.StatusEnum.Closed,
							].includes(<FulfilmentWindowSummarySlot.StatusEnum>fulfillmentWindowSummarySlot.status)
					  );
				return this.getDriveInstructions(slots);
			})
		);
	}

	getDriveInstructions(slots: FulfilmentWindowSummarySlot[]): string {
		const hasDriveUpOffering = slots.some((slot) =>
			slot.offerings?.some((offering) => offering.value === 'DriveUp')
		);

		return hasDriveUpOffering ? 'If possible, please reverse in' : 'If possible, please drive through';
	}
}
